import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckRanTemplateAvailable } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithIdName } from '@utils/formatter';

import { TConsistencyCheckRanGetAvailableTemplatesDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { TIdName } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_RAN_GET_AVAILABLE_TEMPLATES } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckRanGetAvailableTemplates {
	availableTemplates: TSelectOption<string>[];
	isLoadingAvailableTemplates: boolean;
}

const useQueryConsistencyCheckRanGetAvailableTemplates = (
	params: TConsistencyCheckRanGetAvailableTemplatesDTO,
): IUseQueryConsistencyCheckRanGetAvailableTemplates => {
	const {
		data,
		isInitialLoading,
	} = useQuery<TIdName[], TSelectOption<string>[]>({
		queryKey: [CONSISTENCY_RAN_GET_AVAILABLE_TEMPLATES, params],
		queryFn: extractQueryParams(getConsistencyCheckRanTemplateAvailable),
		select: (data) => optionsFormattedWithIdName(data),
		enabled: [!!params.filter || !!params.isAll || !!params.ids],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		availableTemplates: data || [],
		isLoadingAvailableTemplates: isInitialLoading,
	};
};

export default useQueryConsistencyCheckRanGetAvailableTemplates;
